"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.finalise = exports.upload = exports.prepare = void 0;
var qs_1 = __importDefault(require("qs"));
var uuid_1 = __importDefault(require("../helpers/uuid"));
var uploader_1 = require("../uploader");
var utils_1 = require("./utils");
var prepare = function (isPublic) { return __awaiter(void 0, void 0, void 0, function () {
    var axios, url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, utils_1.getAxios)(isPublic)];
            case 1:
                axios = _a.sent();
                url = "".concat((0, utils_1.getEndpoint)(isPublic), "/prepare");
                return [2 /*return*/, axios.post(url, null, { headers: { 'request-id': (0, uuid_1.default)() } })]; // request-id is added as a workaround for a Safari bug
        }
    });
}); };
exports.prepare = prepare;
var upload = function (chunk, cancelToken, uploader, fileUpload) { return __awaiter(void 0, void 0, void 0, function () {
    var axios, data, hash, fileId, url, requestConfig;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, utils_1.getAxios)(uploader.isPublic)];
            case 1:
                axios = _a.sent();
                data = chunk.data, hash = chunk.hash, fileId = chunk.fileId;
                url = (0, utils_1.getUploadURL)(chunk, uploader.isPublic);
                requestConfig = {
                    onUploadProgress: function (progressEvent) {
                        uploader.events.onProgress(fileId, 
                        // TODO: Turn this into a better maintainable implementation
                        (0, uploader_1.calculateFileProgress)(chunk.id, chunk.fileId, (100 / progressEvent.total) * progressEvent.loaded), fileUpload.id);
                    },
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Content-SHA256': hash
                    },
                    withCredentials: true,
                    cancelToken: cancelToken
                };
                // Send post request
                return [2 /*return*/, axios.post(url, data, requestConfig)];
        }
    });
}); };
exports.upload = upload;
var finalise = function (fileUpload) { return __awaiter(void 0, void 0, void 0, function () {
    var fileId, fileName, fileSize, chunksCount, fileHash, uploader, axios, url, data, requestConfig;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                fileId = fileUpload.fileId, fileName = fileUpload.fileName, fileSize = fileUpload.fileSize, chunksCount = fileUpload.chunksCount, fileHash = fileUpload.fileHash, uploader = fileUpload.uploader;
                return [4 /*yield*/, (0, utils_1.getAxios)(uploader.isPublic)];
            case 1:
                axios = _a.sent();
                url = (0, utils_1.getFinaliseURL)(fileId, uploader.isPublic);
                data = qs_1.default.stringify({
                    sha256: fileHash,
                    fileName: fileName,
                    chunksCount: chunksCount,
                    fileSize: fileSize,
                    intent: uploader.intent
                });
                requestConfig = {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                };
                return [2 /*return*/, axios.post(url, data, requestConfig)];
        }
    });
}); };
exports.finalise = finalise;
//# sourceMappingURL=index.js.map